import React from 'react';
import { FaUserFriends, FaBrain, FaShip, FaRocket, FaChartLine } from 'react-icons/fa';

const Intro = () => {
  return (
    <section className="py-16 sm:py-20 px-6 sm:px-8 lg:px-12 bg-white min-h-screen flex items-center">
      <div className="max-w-7xl mx-auto w-full">
        {/* Hero Section */}
        <div className="flex flex-col lg:flex-row items-center justify-between gap-12 mb-24">
          {/* Text Content */}
          <div className="flex-1 space-y-6">
            <span className="inline-block bg-gradient-to-r from-orange-300 to-pink-300 text-white px-4 py-2 rounded-full text-sm font-semibold">
              Who We Are
            </span>
            <h1 className="text-4xl sm:text-5xl md:text-6xl font-light text-gray-900 leading-tight tracking-tight">
              Digital Growth <span className="font-semibold">Partners</span><br />
              For Modern Businesses
            </h1>
            <p className="text-xl font-light text-gray-600 max-w-2xl leading-relaxed">
              <span className="font-semibold bg-gradient-to-r from-orange-400 to-pink-400 bg-clip-text text-transparent">CYBORGSAPIENT</span> is your strategic partner in navigating the digital landscape. We combine data-driven insights with creative execution to deliver measurable results.
            </p>
          </div>

          {/* Image */}
          <div className="flex-1 flex justify-center">
            <div className="relative w-full max-w-md">
              <img
                src="https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
                alt="Team collaboration"
                className="relative rounded-3xl shadow-xl object-cover w-full h-auto border border-gray-200"
                loading="lazy"
              />
            </div>
          </div>
        </div>

        {/* Value Propositions */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-24">
          {/* Card 1 */}
          <div className="bg-white p-8 rounded-2xl border border-gray-200 hover:shadow-xl transition-all">
            <div className="bg-gradient-to-br from-orange-100 to-pink-100 w-14 h-14 rounded-xl flex items-center justify-center mb-6">
              <FaUserFriends className="text-orange-400 text-2xl" />
            </div>
            <h3 className="text-2xl font-semibold text-gray-900 mb-3">Massive Audience Reach</h3>
            <p className="text-gray-600 leading-relaxed">
              With over <span className="font-semibold bg-gradient-to-r from-orange-400 to-pink-400 bg-clip-text text-transparent">400 million+ users</span> online in India, we help you precisely target your ideal customers through sophisticated digital channels.
            </p>
          </div>

          {/* Card 2 */}
          <div className="bg-white p-8 rounded-2xl border border-gray-200 hover:shadow-xl transition-all">
            <div className="bg-gradient-to-br from-pink-100 to-purple-100 w-14 h-14 rounded-xl flex items-center justify-center mb-6">
              <FaBrain className="text-pink-400 text-2xl" />
            </div>
            <h3 className="text-2xl font-semibold text-gray-900 mb-3">Strategic Expertise</h3>
            <p className="text-gray-600 leading-relaxed">
              Our team of <span className="font-semibold bg-gradient-to-r from-pink-400 to-purple-400 bg-clip-text text-transparent">digital specialists</span> brings cutting-edge strategies tailored to your business objectives and market position.
            </p>
          </div>

          {/* Card 3 */}
          <div className="bg-white p-8 rounded-2xl border border-gray-200 hover:shadow-xl transition-all">
            <div className="bg-gradient-to-br from-purple-100 to-blue-100 w-14 h-14 rounded-xl flex items-center justify-center mb-6">
              <FaShip className="text-purple-400 text-2xl" />
            </div>
            <h3 className="text-2xl font-semibold text-gray-900 mb-3">Future-Ready Solutions</h3>
            <p className="text-gray-600 leading-relaxed">
              In today's digital economy, we equip you to <span className="font-semibold bg-gradient-to-r from-purple-400 to-blue-400 bg-clip-text text-transparent">navigate change</span> and stay ahead of evolving consumer behaviors and technologies.
            </p>
          </div>
        </div>

        {/* Stats Section */}
        <div className="bg-gradient-to-r from-orange-300 via-pink-300 to-purple-300 rounded-3xl p-8 md:p-12">
          <h2 className="text-3xl sm:text-4xl font-light text-white mb-12 tracking-tight text-center">
            Our Impact in <span className="font-semibold">Numbers</span>
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="text-4xl md:text-5xl font-light text-white mb-2">150+</div>
              <div className="text-white/90 font-light">Clients Served</div>
            </div>
            <div className="text-center">
              <div className="text-4xl md:text-5xl font-light text-white mb-2">85%</div>
              <div className="text-white/90 font-light">Retention Rate</div>
            </div>
            <div className="text-center">
              <div className="text-4xl md:text-5xl font-light text-white mb-2">3.5x</div>
              <div className="text-white/90 font-light">Avg. ROI</div>
            </div>
            <div className="text-center">
              <div className="text-4xl md:text-5xl font-light text-white mb-2">24/7</div>
              <div className="text-white/90 font-light">Support</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Intro;